import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { TitleHeader } from 'web-library';
import { candidateService } from '../../../api';
import { ExamRegistrationType } from '../../../api/candidate/exam/model';

const ExamTitle = ({ enableApi = true }: { enableApi?: boolean }) => {
  const { t } = useTranslation();
  const examRegistrationTitle = t('exam->>RegisterExam.RegisterForAnExam');
  const lateRegistrationTitle = t(
    'exam->>SupplementaryRegistration.RegisterForAnExamSupplementary'
  );

  const [examTitle, setExamTitle] = useState<string>(examRegistrationTitle);

  // @ts-ignore
  const { uuid: examRegistrationUuid } = useParams();

  const { data } = candidateService.exam.candidate.useGetExamRegistration(examRegistrationUuid, {
    enabled: enableApi,
  });

  useEffect(() => {
    if (examRegistrationUuid && data && data.examRegistrationType !== ExamRegistrationType.EXAM) {
      setExamTitle(lateRegistrationTitle);
    }
  }, [data, examRegistrationUuid, lateRegistrationTitle]);

  return <TitleHeader title={examTitle} />;
};

export default ExamTitle;
